import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import axios from 'axios';
import { baseAPI } from '../../services/baseAPI';

function PengajuanTabungan() {
  const { id, npp } = useParams();
  const history = useHistory();
  const ADMIN = 1;
  const ANGGOTA = 2;
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(true);
  const [newData, setNewData] = useState([{
    tgl_mulai: "",
    jangka:0,
    setoran: "",
    total: "",
    no_rekening: "",
    nama_bank: "",
    atas_nama: "",
  }]);
  const [listTargetTabungan, setListTargetTabungan] = useState([
    { label: "Rp.1.000.000", value: 1000000 },
    { label: "Rp.2.000.000", value: 2000000 },
    { label: "Rp.3.000.000", value: 3000000 },
    { label: "Rp.4.000.000", value: 4000000 },
    { label: "Rp.5.000.000", value: 5000000 },
    { label: "Rp.6.000.000", value: 6000000 },
    { label: "Rp.7.000.000", value: 7000000 },
    { label: "Rp.8.000.000", value: 8000000 },
    { label: "Rp.9.000.000", value: 9000000 },
    { label: "Rp.10.000.000", value: 10000000 },
  ]);
  const [empTargetTabungan, setEmpTargetTabungan] = useState([]);
  const [listLamaTabungan, setListLamaTabungan] = useState([
    { label: "6 - Bulan", value: 6 },
    { label: "12 - Bulan", value: 12 },
    { label: "18 - Bulan", value: 18 },
    { label: "24 - Bulan", value: 24 },
  ])
  const [empLamaTabungan, setEmpLamaTabungan] = useState(0);
  const [empSetorTabungan, setEmpSetorTabungan] = useState([]);
  const [empData, setEmpData] = useState([]);
  const [tabungRate, setTabungRate] = useState([]);


  // CONTROLLER

  const fetchUserData = async (id) => {
    setIsLoading(true);
    await axios
      .all(
        [
        baseAPI .get(`/v1/user/${id}`, { headers: { Authorization: `Bearer ${token}` } }),
        baseAPI .get(`/v1/tabungrate`, { headers: { Authorization: `Bearer ${token}` } }),
        ]
      )
      .then((res) => {
        const data = res[0].data.data.userData;       
        const tabungRate = res[1].data.data.tabungrate;       
        setEmpData(data[0]);
        setTabungRate(tabungRate);
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: 'error',
          title: `Gagal mengambil data`,
          showConfirmButton: false,
          timer: 1500
        })
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const storeNewTabungan = async (id) => {
    
    Swal.fire({
      title: 'Apakah data pengajuan tabungan anda sudah benar?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Ajukan',
      denyButtonText: `Jangan Ajukan`,
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        
        const body = new FormData();
        body.append('new_data', JSON.stringify(newData));

        baseAPI
          .post(`/v1/detailtabung/${id}`, body, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: "Data pengajuan tabungan sudah diajukan.",
              showConfirmButton: false,
              timer: 1500
            })
            console.log(`berhasil upload ${JSON.stringify(res)}`);
            setEmpTargetTabungan([]);
            setEmpLamaTabungan([]);
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Data pengajuan tabungan gagal diajukan.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setIsLoading(false);
            fetchUserData(id);
          })
      } else if (result.isDenied) {
        Swal.fire('Silahkan periksa ulang data pengajuan anda.', '', 'info')
      }
    });

  }

  const checkCicilanTabungan = (jangka, target) => {
    if (jangka !== 0) {
      // let hitung = (target / jangka).toFixed(0);

      let matchedRate = null;

      // Find the matching rate
      tabungRate.some(e => {
        if (e.plafond === target && e.tenor === jangka) {
          matchedRate = e;
          return true; // Stop iterating after the first match
        }
        return false;
      });

      if (matchedRate) {
        let hitung = (matchedRate.cicilan).toFixed(0);
        let rupiahFormat = parseFloat(hitung).toLocaleString('id-ID'); // 'id-ID' is the locale for Indonesian Rupiah
        setEmpSetorTabungan("Rp." + rupiahFormat);
        setNewData([{...newData[0], jangka: jangka, total: target, setoran: hitung}])
      }
    }
  }

  useEffect(() => {
    // if (user.role === ANGGOTA) {
      fetchUserData(user.id);
    // };
  }, [token]);
  

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='#' style={{ color: '#333' }}>Tabungan</Link> /{' '}
              <Link to='/tabungan/pengajuan' style={{ color: '#333' }}>Pengajuan Tabungan</Link>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Formulir Pengajuan Tabungan</b></p>
                <p>Silahkan mengisi formulir pengajuan tabungan berikut untuk mengajukan tabungan.</p>
              </div>

              {/* Target tabungan */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Prakira Target Tabungan
                </label>
                <Select
                  options={listTargetTabungan}
                  defaultValue={listTargetTabungan && empTargetTabungan}
                  placeholder="Pilih target"
                  onChange={e => {
                    setEmpTargetTabungan(e.label)
                    setNewData([{...newData[0], total: e.value}])
                    checkCicilanTabungan(empLamaTabungan, e.value);
                  }}
                />
              </div>

              {/* Lama Tabungan */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Prakira Lama Tabungan
                </label>
                <Select
                  isDisabled={newData[0].total !== "" ? false : true}
                  options={listLamaTabungan}
                  defaultValue={listLamaTabungan && empLamaTabungan}
                  placeholder="Pilih jangka tabungan"
                  onChange={e => {
                    setEmpLamaTabungan(e.value)
                    setNewData([{...newData[0], jangka: e.value}])
                    checkCicilanTabungan(e.value, newData[0].total);
                  }}
                />
              </div>

              {/* Target tabungan fix */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Target Tabungan
                </label>
                <input
                  defaultValue={empTargetTabungan}
                  placeholder='Target tabungan'
                  className="form-control"
                  onChange={e => setNewData([{...newData[0], total: e.target.value}])}
                />
              </div>

              {/* Besar setoran */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Besar Setoran
                </label>
                <input
                  defaultValue={empSetorTabungan}
                  placeholder='Target tabungan'
                  className="form-control"
                  onChange={e => {
                    setNewData([{...newData[0], setoran: e.target.value}])
                  }}
                />
              </div>

              {/* Name */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Name
                </label>
                <input
                  defaultValue={empData.name_anggota}
                  readOnly
                  placeholder='Employee name'
                  className="form-control"
                  // onChange={e => setNewData([{...newData[0], name_anggota: e.target.value}])}
                />
              </div>

              {/* No Rekening */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  No Rekening
                </label>
                <input
                  defaultValue={empData.no_rekening}
                  readOnly
                  placeholder='Nomor rekening'
                  className="form-control"
                  // onChange={e => setNewData([{...newData[0], no_rekening: e.target.value}])}
                />
              </div>

              {/* Tanggal pembuatan */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Tanggal Pembuatan
                </label>
                <DatePicker
                  selected={newData[0].tgl_mulai !== "" ? moment(newData[0].tgl_mulai, "DD/MM/YYYY").utcOffset(7, true).toDate() : moment().utcOffset(7, true).toDate()}
                  placeholderText="Pilih tanggal"
                  className="form-control datepicker"
                  onChange={date => setNewData([{...newData[0], tgl_mulai: date}])}
                  dateFormat="dd/MM/yyyy"
                />

              </div>

              {/* No rekening pencairan */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  No Rekening Pencairan
                </label>
                <input
                  // defaultValue={empData.no_rekening}
                  required
                  placeholder='Rekening pencairan'
                  className="form-control"
                  onChange={e => setNewData([{...newData[0], no_rekening: e.target.value}])}
                />
              </div>
              
              {/* Nama bank */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Nama Bank
                </label>
                <input
                  // defaultValue={empData.nama_bank}
                  required
                  placeholder='Nama bank'
                  className="form-control"
                  onChange={e => setNewData([{...newData[0], nama_bank: e.target.value}])}
                />
              </div>
              
              {/* Atas nama rekening pencairan */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Atas Nama Rekening Pencairan
                </label>
                <input
                  // defaultValue={empData.atas_nama}
                  required
                  placeholder='Atas nama'
                  className="form-control"
                  onChange={e => setNewData([{...newData[0], atas_nama: e.target.value}])}
                />
              </div>
              
              <div className='col-md-12'>
                <button
                  disabled={newData[0].no_rekening !== "" && newData[0].nama_bank !== "" && newData[0].atas_nama !== "" ? false : true}
                  type="button"
                  className='btn btn-danger col-md-12'
                  style={{backgroundColor: "#9681EB"}}
                  onClick={() => storeNewTabungan(user.id)}
                >
                  Ajukan
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}
      {/* {addView()} */}

    </div>
  );

}

export default PengajuanTabungan;